import MainPage from "./pages/MainPage";
import Settings from "./pages/Settings";
import Nav from "./components/Nav";
import { Routes, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { mobile, laptop, tablet } from "./libs/screenSizes";

const GeneralStyles = createGlobalStyle`
  body{
    background-color:${({ theme }) => theme.background};
    transition-duration: ${({ theme }) => theme.transitionDuration}
  }

  @media ${mobile}{
    :root{
      font-size:9px
    }
  }
`;

function App() {
  return (
    <>
      <GeneralStyles />
      <Nav />
      <Routes>
        <Route path="timer" element={<MainPage />} />
        <Route path="settings" element={<Settings />} />
        <Route path="/" element={<MainPage />} />
      </Routes>
    </>
  );
}
export default App;
